module.exports = __webpack_public_path__ + "assets/img/tx102s_2.68c1c90a.jpg";